import { useEffect, useState } from 'react';

import { RAISON_PERSONNES, usePersonnesPort, type PersonneVue } from '../lib/personnes.js';
import { ENTREE_LIA, ENTREE_TOUS, jetonDePersonne, type EntreeDeMention } from './mentions.js';

/** Pure : l'annuaire en entrees de mention, personnes NON retirees, triees par nom, puis @tous et @Lia. */
export function entreesDeMention(personnes: readonly PersonneVue[]): EntreeDeMention[] {
  const actives = personnes
    .filter((p) => !p.archive)
    .map<EntreeDeMention>((p) => ({
      id: p.personId,
      genre: 'personne',
      libelle: p.displayName.trim() !== '' ? p.displayName.trim() : p.email,
      detail: p.email,
      jeton: jetonDePersonne(p.personId),
      ...(p.photoURL ? { photoURL: p.photoURL } : {}),
    }))
    .sort((a, b) => a.libelle.localeCompare(b.libelle, 'fr'));
  return [...actives, ENTREE_TOUS, ENTREE_LIA];
}

export interface SourceDeMentions {
  entrees: EntreeDeMention[];
  /** L'annuaire est lu (ou son absence constatee). */
  pret: boolean;
  /** Pourquoi la liste n'a que @tous et @Lia (pas de port, lecture refusee). G16. */
  raison: string | null;
}

/**
 * LA SOURCE DES MENTIONS : les personnes de l'org non retirees
 * (`PersonnesProvider`, la meme source que le champ Intervenant), plus
 * `@tous` et `@Lia`. Sans port, la liste ne propose que les deux entrees
 * speciales et le dit.
 */
export function useSourceDeMentions(): SourceDeMentions {
  const port = usePersonnesPort();
  const [etat, setEtat] = useState<SourceDeMentions>({ entrees: [ENTREE_TOUS, ENTREE_LIA], pret: false, raison: null });
  useEffect(() => {
    if (port === null) {
      setEtat({ entrees: [ENTREE_TOUS, ENTREE_LIA], pret: true, raison: RAISON_PERSONNES.sansPort });
      return;
    }
    let annule = false;
    port.lister().then(
      (personnes) => { if (!annule) setEtat({ entrees: entreesDeMention(personnes), pret: true, raison: null }); },
      (cause: unknown) => {
        if (annule) return;
        const message = cause instanceof Error ? cause.message : String(cause);
        setEtat({ entrees: [ENTREE_TOUS, ENTREE_LIA], pret: true, raison: `L'annuaire des personnes est illisible : ${message}` });
      },
    );
    return () => { annule = true; };
  }, [port]);
  return etat;
}
